/**
 * @generated SignedSource<<e537eeb933673e6a2764fb86073f30e3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Anthropic" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type TriggerOrganizationScanInput = {
  orgs?: ReadonlyArray<OrganizationScanInput> | null | undefined;
};
export type OrganizationScanInput = {
  key: string;
  provider: CloudProvider;
};
export type TriggerOrganizationScanMutation$variables = {
  input: TriggerOrganizationScanInput;
};
export type TriggerOrganizationScanMutation$data = {
  readonly triggerOrganizationScan: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly scans: ReadonlyArray<{
      readonly uuid: any;
    }> | null | undefined;
  } | null | undefined;
};
export type TriggerOrganizationScanMutation = {
  response: TriggerOrganizationScanMutation$data;
  variables: TriggerOrganizationScanMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TriggerOrganizationScanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "TriggerOrganizationScanPayload",
        "kind": "LinkedField",
        "name": "triggerOrganizationScan",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountScan",
            "kind": "LinkedField",
            "name": "scans",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "TriggerOrganizationScanMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "TriggerOrganizationScanPayload",
        "kind": "LinkedField",
        "name": "triggerOrganizationScan",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountScan",
            "kind": "LinkedField",
            "name": "scans",
            "plural": true,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "05feb85ebb8ea5bfddb0ebfb9111e3b9",
    "id": null,
    "metadata": {},
    "name": "TriggerOrganizationScanMutation",
    "operationKind": "mutation",
    "text": "mutation TriggerOrganizationScanMutation(\n  $input: TriggerOrganizationScanInput!\n) {\n  triggerOrganizationScan(input: $input) {\n    problems {\n      __typename\n      message\n    }\n    scans {\n      uuid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b03ce5882ba6028ba861b06bcb591a8";

export default node;
